/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {BuildMessage, EventDependentComponent, PopulateAreaSpecificData} from './areaContracts'
import {populateDetailedViewData} from './detailedView/populateDetailedViewData'
import {buildDetailedViewMessage} from './detailedView/buildDetailedViewFunction'
import {DetailedViewTableView} from './detailedView/DetailedViewTableView'
import {DetailedViewDiffViewer} from './detailedView/DetailedViewDiffViewer'
import intl from '../utils/intl/intl'
import { SyncProfileDiffViewer } from './syncProfile/SyncProfileDiffViewer'
import { populateSyncProfileData } from './syncProfile/populateSyncProfileData'
import { SyncProfileTableView } from './syncProfile/SyncProfileTableView'
import { buildSyncProfileMessage } from './syncProfile/buildSyncProfileFunction'

type KnownAreas = 'detailedView' | 'syncProfile'
type AreaDependent<T> = Record<KnownAreas, T>

export const knownAreas: AreaDependent<string> = {
  detailedView: intl.formatMessage('Detailed View'),
  syncProfile: intl.formatMessage('Sync Profile')
}

export const knownAreasList = Object.keys(knownAreas).sort()

export interface AreaDependentComponents {
  populateData?: PopulateAreaSpecificData
  buildMessage?: BuildMessage
  TableViewComponent?: EventDependentComponent
  ExpandedRowAdditionalComponent?: EventDependentComponent
}

export const areaDependentComponents: AreaDependent<AreaDependentComponents> = {
  detailedView: {
    populateData: populateDetailedViewData,
    buildMessage: buildDetailedViewMessage,
    TableViewComponent: DetailedViewTableView,
    ExpandedRowAdditionalComponent: DetailedViewDiffViewer
  },
  syncProfile: {
    populateData: populateSyncProfileData,
    buildMessage: buildSyncProfileMessage,
    TableViewComponent: SyncProfileTableView,
    ExpandedRowAdditionalComponent: SyncProfileDiffViewer
  }
}
